import { AppSyncResponse } from '@helpers/appSyncResponse.helper';
import { ApolloQueryResult } from 'apollo-client';

export class Service {
    public id!: string;
    public name!: string;
    public categoryList!: string[];
    public employeeIDList?: string[];
    public resourceIDList?: string[];
    public duration!: number;
    public lowestPrice!: number;
    public hasPriceException!: boolean;
    public longestDuration!: number;
    public hasDurationException!: boolean;
    public depositRequired?: boolean;
    public depositPercentage?: number;
    public depositFixedAmount?: number;
    public webOrder?: number | null;
    public price!: number;
    public description?: string;

    public constructor(init?: Partial<Service>) {
        Object.assign(this, init);
    }

    public static deserializeAppSyncResponse(appSyncResponse: ApolloQueryResult<AppSyncResponse>): Service[] {
        return AppSyncResponse.parseResponse(appSyncResponse.data, (obj: Service[]) => obj.map((e: Service) => e), [
            'getServiceList',
            'serviceList',
        ]);
    }
}
